import { render } from "./PlanCard.vue?vue&type=template&id=0b123320&scoped=true"
import script from "./PlanCard.vue?vue&type=script&lang=js"
export * from "./PlanCard.vue?vue&type=script&lang=js"

import "./PlanCard.vue?vue&type=style&index=0&id=0b123320&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b123320"]])

export default __exports__